import "bootstrap/dist/css/bootstrap.min.css"
import "../legacy/custom.css"
import { createConsumer } from "@rails/actioncable"
import "../composables/bridges/app_core.js"

import { mountVueComponents } from "../mounts"

let cableConsumer = null
let vmStateSubscription = null
let hyperVisorStateSubscription = null

function cableUrl() {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:"
  return `${protocol}//${window.location.host}/cable`
}

function ensureCableConsumer() {
  if (cableConsumer) {
    return cableConsumer
  }

  cableConsumer = createConsumer(cableUrl())
  return cableConsumer
}

function ensureLiveUpdateSubscriptions() {
  const consumer = ensureCableConsumer()

  if (!vmStateSubscription) {
    vmStateSubscription = consumer.subscriptions.create("VmStateChannel", {
      received(payload) {
        document.dispatchEvent(new CustomEvent("scc:vm-state-changed", { detail: payload || {} }))
      }
    })
  }

  if (!hyperVisorStateSubscription) {
    hyperVisorStateSubscription = consumer.subscriptions.create("HyperVisorStateChannel", {
      received(payload) {
        document.dispatchEvent(new CustomEvent("scc:hyper-visor-state-changed", { detail: payload || {} }))
      }
    })
  }
}

ensureLiveUpdateSubscriptions()
mountVueComponents()
